import { Trash2 } from "@tamagui/lucide-icons";

import { LoadingSpinner, Text, XStack, YStack } from "@/components";
import { Button } from "@/components/Button";

type SettingsListItemProps = {
  title: string;
  subtitle?: string;
  onDelete: () => void;
  isDeleting?: boolean;
  disabled?: boolean;
};

export default function SettingsListItem({
  title,
  subtitle,
  onDelete,
  isDeleting = false,
  disabled = false,
}: SettingsListItemProps) {
  return (
    <XStack
      alignItems="center"
      justifyContent="space-between"
      borderRadius="$100"
      borderWidth="$strokeWidth"
      borderColor="$strokeSubdued"
      backgroundColor="$tileBackground"
      width="100%"
      padding="$150"
      gap="$100"
    >
      <YStack gap="$75" flex={1}>
        <Text size="$sm" numberOfLines={0}>
          {title}
        </Text>
        {subtitle && (
          <Text size="$xs" color="$textSecondary">
            {subtitle}
          </Text>
        )}
      </YStack>
      <Button.Wrapper
        onPress={onDelete}
        disabled={disabled || isDeleting}
        flexShrink={0}
        aria-label="Delete"
      >
        {isDeleting ? (
          <LoadingSpinner size={16} />
        ) : (
          <Trash2
            size="$250"
            color={disabled || isDeleting ? "$textDisabled" : "$textPrimary"}
            cursor={disabled || isDeleting ? "not-allowed" : "pointer"}
          />
        )}
      </Button.Wrapper>
    </XStack>
  );
}
